<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import Plane from "@/Components/Generics/Plane.vue";
import MainPage from "@/Components/MainPage.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        MainPage,
        Plane,
        GenericButton,
    },
    layout: Authenticated,
    props: {
        status: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            form: this.$inertia.form(),
        };
    },
    computed: {
        verificationLinkSent(): boolean {
            return this.status === "verification-link-sent";
        },
    },
    methods: {
        submit(): void {
            this.form.post(this.route("verification.send"));
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('auth.verify_email')">
        <Plane class="verify-email-plane" :darker="true">
            <div class="flex flex--width flex--v flex--gap-20">
                <span class="text text--primary-b text--size-18 text--medium text--height-22 text--center">
                    {{ $trans("auth.verify_email_1") }}
                </span>
                <span class="text text--primary-b text--size-18 text--medium text--height-22 text--center">
                    {{ $trans("auth.verify_email_2") }}
                </span>

                <span v-if="verificationLinkSent" class="text text--secondary-b text--size-18 text--medium text--height-22 text--center">
                    {{ $trans("auth.verify_email_sent") }}
                </span>

                <form class="full-width" @submit.prevent="submit">
                    <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                        <GenericButton class="verify-email-button" :title="$trans('auth.verify_email_resend_mail')" :disabled="form.processing" @click="submit" />

                        <InertiaLink :href="route('logout')" method="post" class="inertia-link text text--less-gap text--primary-b text--size-16 text--center">{{ $trans("auth.logout") }}</InertiaLink>
                    </div>
                </form>
            </div>
        </Plane>
    </MainPage>
</template>

<style lang="scss" scoped>
.verify-email-plane {
    max-width: rem(500);
    margin: 0 auto;

    .verify-email-button {
        height: rem(45);
        margin-top: rem(5);
    }

    .inertia-link {
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
